import { useMantineColorScheme } from "@mantine/core";

/**
 * Custom hook to manage color scheme (light/dark mode) in the application.
 * @param props - Optional props to customize the color scheme behavior.
 * @returns An object containing the current color scheme and a function to toggle it.
 */
export const useColorScheme: typeof useMantineColorScheme = (props) => {
    return useMantineColorScheme(props);
};
